import { Link } from 'react-router';
import { Icon } from '../components/Icon';
import { Seo } from '../components/Seo';
import { siteConfig } from '../config/site';

export function ChangelogPage() {
  return (
    <>
      <Seo title="Product updates" description="Release notes and version history for Wavecraft Audio plugins." path="/changelog" />
      <section className="page-hero changelog-hero section--grain">
        <div className="shell page-hero__grid">
          <div><span className="eyebrow eyebrow--line">Product updates</span><h1>What changed, when it changed and why it is worth installing.</h1></div>
          <div className="page-hero__aside"><p>Use this page for release notes, installer notices, compatibility changes and known issues. Keep each entry specific enough to help customers decide whether to update a working session.</p></div>
        </div>
      </section>

      <section className="section changelog-section">
        <div className="shell changelog-list">
          {siteConfig.changelog.map((entry, index) => (
            <article className="changelog-entry" key={`${entry.product}-${entry.version}`}>
              <div className="changelog-entry__date"><span>0{index + 1}</span><time dateTime={entry.date}>{entry.date}</time></div>
              <div className="changelog-entry__body">
                <div className="changelog-entry__heading"><h2>{entry.product}</h2><span>Version {entry.version}</span></div>
                <ul>{entry.notes.map((note) => <li key={note}><Icon name="check" />{note}</li>)}</ul>
                <Link to={`/plugins/${entry.product.toLowerCase()}`}>Product page <Icon name="arrow" /></Link>
              </div>
            </article>
          ))}
          <div className="changelog-placeholder">
            <Icon name="clock" />
            <div><strong>Add future releases in one file</strong><p>Edit the <code>changelog</code> array in <code>src/config/site.ts</code>. No page layout changes are required.</p></div>
          </div>
        </div>
      </section>
    </>
  );
}
